export const environment = {
  production: true,
  apihost: ['https://sygidan-tas-server.revenuedev.org/gov'],
  extApihost: ['https://sygidan-tas-server.revenuedev.org/ext'],
  accessToken: 'tas_gov_access_token',
  boundary: [-9.5, 3.4, -1.9, 11.2],
  govinLink: "https://sygidan-govin.revenuedev.org",
  landingPage: 'dashboard',
  default_lang: 'fr',
  synchronizationInterval: 10,
      currency: {
    currencyName: "XOF"
  },
  baseLayers: [
    {
      name: 'RDF StreetMap',
      rasterTileUrl: 'https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=Ey9CetcV9dDN1Gv1fHRF',
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    },
    {
      name: 'No Buildings',
      rasterTileUrl: 'https://api.maptiler.com/maps/0199285a-acd7-727f-88b4-fec2ea8115fe/{z}/{x}/{y}.jpg?key=Ey9CetcV9dDN1Gv1fHRF',
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    },
  ],
  env: 'prod'
};
